import { CIcon } from '~/icons/types'
export const ciParking: CIcon = {
  name: 'parking',
  type: 'regular',
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M19 2H5C3.3 2 2 3.3 2 5v14c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3Zm1 17c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V5c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v14Z'
    },
    {
      d:
        'M8.9 6.198c-.5 0-.9.4-.9.9v9.9c0 .6.4 1 1 1s1-.4 1-1v-2c2.8.2 4.6-.2 5.7-1.2.9-.8 1.3-1.8 1.3-3.3 0-1.4-.4-2.4-1.3-3.2-1.4-1.2-3.6-1.5-6.8-1.1Zm5.5 6.1c-.7.6-2.2.8-4.4.6v-4.9c2.6-.2 3.8.3 4.3.8.4.4.7.9.7 1.7 0 1.2-.3 1.6-.6 1.8Z'
    }
  ]
}
